module.exports = __webpack_public_path__ + "static/media/click.740a9a94.svg";